import React, { FC, useContext } from 'react';
import { ContextApi } from 'react-uforms';
import { Question } from '@ch/common/types/data';
import { FormTextArea } from '@ch/common/components/form/textarea';
import { replaceSpecialChars } from '@ch/common/utils/helpers';
import { useData } from '../use-data';

const QuizFieldTextarea: FC<Question> = ({ identifier: name, placeholder, disabled }) => {
  const {
    data: { Ascii_replace: replace },
  } = useData();
  const { setValue, getErrors } = useContext(ContextApi);
  return (
    <FormTextArea
      {...{ name, placeholder, disabled, $error: !!getErrors(name)?.length }}
      onChange={e => {
        setValue(name, replaceSpecialChars((e.target as any).value, replace));
      }}
    />
  );
};

export default QuizFieldTextarea;
